import React from 'react';
import { Avatar as FabAvatar } from '~components/avatar';
import type { AvatarProps } from './avatar.types';

export const Avatar = (props: AvatarProps) => <FabAvatar {...props} size={48} />;
